import { ContainerProps } from '../../interfaces/container.interface'
import c from 'classnames'
import styles from './SnackBar.module.scss'

interface SnackBarProps extends ContainerProps {
    showSnackBar?: boolean
}

const SnackBarComponent = ({ showSnackBar, children }: SnackBarProps) => {
    return (
        <div className={c(
            styles.snackBar,
            showSnackBar && styles.showSnackBar
        )}>
            {children}
        </div>
    )
}

export default SnackBarComponent
